
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/warunki-narciarskie-opinie",
      function () {
        return require("private-next-pages/[region]/[resort]/warunki-narciarskie-opinie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/warunki-narciarskie-opinie"])
      });
    }
  